

// editor.on('text-change', (delta, oldDelta, source) => {
//   let insertEvents = delta.ops.filter(op => op.hasOwnProperty('insert'));
//   if (insertEvents.length === 0 || editor.getSelection() === null) return;

//   let cursorIndex = editor.getSelection().index;
//   let text = editor.getContents(0, cursorIndex).ops.map(op => op.insert).join("");

//   let matchArr, start, length, curFormat;
//   while ((matchArr = boldRegex.exec(text)) !== null) {
//     start = matchArr.index;
//     length = matchArr[0].length;
//     curFormat = editor.getFormat(start, length);
//     if (curFormat !== null && curFormat.bold) return;
//     editor.formatText(start, length, 'bold', true);

//     // Is there a better way to do this part, so the next key pressed isn't bold too?
//     editor.format('bold', false);
//   }
// });

/* eslint-disable dot-notation */
import Quill from 'quill';
import { Range } from 'quill/core';
import { Rect } from '../../../../platform/geom/Rect';

const Module = Quill.import('core/module');

export interface CustomToolbarOption {
    toolbarId: string;
}

export class CustomToolbar extends Module<CustomToolbarOption> {

    private frame: HTMLElement;

    constructor(quill: Quill, options?: Partial<CustomToolbarOption>) {
        super(quill, options);

        this.frame = document.getElementById(`${options.toolbarId}-frame`);

        quill.on('selection-change', (range, _oldRange, _source) => {
            this.placeToolbar(range);
        });
    }

    public placeToolbar(selection?: Range) {
        const { quill } = this;

        const range = selection ?? quill.getSelection();
        if (!range?.length) {
            this.hideToolbar();
        }
        else {
            const bounds = Rect.fromLike(quill.getBounds(range.index, range.length));
            this.showToolbar(bounds);
        }
    }

    private showToolbar(relRect: Rect) {

        const contRect = Rect.fromLike(this.quill.container.getBoundingClientRect());
        const absRect = relRect.offset(contRect.topLeft());

        const pt = absRect.pointAt(.5, 0);

        if (this.frame) {
            this.frame.style.left = `${pt.x}px`;
            this.frame.style.top = `${pt.y}px`;
            this.frame.style.display = 'block';
        }
    }

    private hideToolbar() {
        if (this.frame) {
            this.frame.style.display = 'none';
        }
    }
}
